import React from 'react';
import PropTypes from 'prop-types';

const BuySell = ({ altText }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1.5em' role='img' aria-labelledby='buy-sell-title'>
      <title id='buy-sell-title'>{altText}</title>
      <path d='M11.5 14a3.5 3.5 0 1 1 3.5-3.5 3.504 3.504 0 0 1-3.5 3.5zm0-5a1.5 1.5 0 1 0 1.5 1.5A1.502 1.502 0 0 0 11.5 9z' />
      <path d='M23 16.48a4.435 4.435 0 0 0-1-2.787V3H1v15h10.047a4.45 4.45 0 0 0 4.432 4.959 4.455 4.455 0 0 0 3.168-1.313 4.286 4.286 0 0 0 .602-.79A4.453 4.453 0 0 0 23 16.48zM11.748 16H3V5h17v7.271A4.424 4.424 0 0 0 18.52 12a4.469 4.469 0 0 0-3.77 2.084 4.43 4.43 0 0 0-2.437 1.228 4.533 4.533 0 0 0-.565.688zm1.979 4.232a2.48 2.48 0 0 1 0-3.506 2.43 2.43 0 0 1 .316-.261l-.001.014a4.483 4.483 0 0 0 2.71 4.111 2.544 2.544 0 0 1-3.025-.358zm4.794-1.274A2.479 2.479 0 1 1 21 16.479a2.482 2.482 0 0 1-2.48 2.479z' />
      <path d='M4 13h4v2H4zM15 6h4v2h-4z' />
    </svg>
  );
};

BuySell.propTypes = {
  altText: PropTypes.string
};

export default BuySell;
